<script lang="ts">
	import type { OperationModel } from '@app/models/api/OperationModel';
	import { t } from 'svelte-i18n';
	import { capitalize, commaToList, rnToBr } from '$lib/utils/strings';
	import TagWhite from '$lib/elements/tags/variants/TagWhite.svelte';

	export let operation: OperationModel;
</script>

{#if operation.commentWhyInvest || operation.commentProgression || operation.commentConcurrency || operation.commentSuperiority}
	<section class="space-y-4">
		<h2>{capitalize($t('operation.analysis'))}</h2>
		{#if operation.commentWhyInvest}
			<div>
				<h3>
					{capitalize($t('operation.goodReason', { values: { operationName: operation.name } }))}
				</h3>
				<p>{@html rnToBr(operation.commentWhyInvest)}</p>
			</div>
		{/if}
		{#if operation.commentProgression}
			<div>
				<h3>{capitalize($t('operation.progressPoint'))}</h3>
				<p>{@html rnToBr(operation.commentProgression)}</p>
			</div>
		{/if}
		{#if operation.commentConcurrency}
			<div>
				<h3>{capitalize($t('operation.concurrency'))}</h3>
				<div class="space-x-2">
					{#each commaToList(operation.commentConcurrency) as item}
						<TagWhite props={{ label: item }} />
					{/each}
				</div>
			</div>
		{/if}
		{#if operation.commentSuperiority}
			<div>
				<h3>{capitalize($t('operation.differential'))}</h3>
				<p>{@html rnToBr(operation.commentSuperiority)}</p>
			</div>
		{/if}
	</section>
{/if}
